import React, { useEffect, useState } from "react";
import {
  Container,
  CourseHeading,
  PopularCourse,
  PopularCourseContent,
  SearchDiv,
  TruncatedText,
} from "./styles";
import SchoolIcon from "@mui/icons-material/School";
import AddIcon from "@mui/icons-material/Add";
import {
  BoldLg,
  RegSm,
  SpaceBetween,
  VerticalLeftAlign,
  HorizontalAlign,
  RegSmPri,
  VerticalAlign,
  HorizontalLeftAlign,
  RegLg,
} from "../../../../Components/CustomStyles";
import { useDispatch, useSelector } from "react-redux";
import images from "../../../../Constant/images";
import SmartImage from "../../../../Components/SmartImage";
import Colors from "../../../../Constant/Colors";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "../../../../Components/IconButton";
import Pagination from "../../../../Components/Pagination";
import ClipLoader from "react-spinners/ClipLoader";
import {
  getCoursesRequest,
  getNewCoursesRequest,
  getWaitingCoursesRequest,
  stripeOnboardRequest,
} from "../../../../Redux/actions/home";
import SearchBar from "../../../../Components/SearchBar";
import CustomSelect from "../../../../Components/CustomSelect";
import ModalComponent from "../../../../Components/Modal";
import { getProfileRequest } from "../../../../Redux/actions/auth";

const CoursesList = ({ handleView }) => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPages] = useState({
    myCourses: 1,
    newCourses: 1,
    waitingCourses: 1,
  });
  const [slug, setSlug] = useState({
    myCourse: '',
    newCourse: '',
    waitingCourse: ''

  })

  const [openPopup, setOpenPopup] = useState({
    addCard: false,
    isFreeCourse: false
  });
  const [slugOptions, setSlugOptions] = useState([]);
  const [searchCourse, setSearchCourse] = useState({
    myCourse: '',
    newCourse: '',
    waitingCourse: ''
  });
  const styles = {
    mainStyle: {
      width: "10%",
      minWidth: 180,
      maxWidth: 250,
    }, searchStyle: { height: 30, marginTop: 0 },
  };


  const { isInstructor, isCardAdded } = useSelector((state) => state.auth);
  const {
    courses,
    awaiting_courses,
    new_courses,
    courseLoading,
    newCourseLoading,
    waitingCourseLoading,
    awaiting_courses_count,
    my_courses_count,
    new_courses_count,
    slugList,
    stripeLoading
  } = useSelector((state) => state.home);

  const handlePopup = (key, value) => {
    setOpenPopup((prev) => ({
      ...prev,
      [key]: value
    }))
  }


  const closeModal = () => {
    setOpenPopup({
      addCard: false,
      isFreeCourse: false
    })

  }
  const addCard = () => {
    dispatch(stripeOnboardRequest("courses"));
    closeModal();
  };
  
  const handlePaidCourse=()=>{
    closeModal();
  handlePopup('addCard', true)
}


  const handleSlug = (obj, type) => {
    let category = obj?.value
    setSlug(prev => ({ ...prev, [type]: category }));
    if (type === 'myCourse') {
      dispatch(getCoursesRequest(0, 4, false, searchCourse?.myCourse, category === 'All' ? '' : category))
    } else if (type === 'newCourse') {
      dispatch(getNewCoursesRequest(0, searchCourse?.newCourse, category === 'All' ? '' : category))
    } else {
      dispatch(getWaitingCoursesRequest(0, searchCourse?.waitingCourse, category === 'All' ? '' : category))
    }
  };

  const setCurrentPage = (page, type) => {
    let offset = page * 4 - 4;
    if (type === "myCourses") {
      dispatch(getCoursesRequest({ offset }));
    } else if (type === "newCourses") {
      dispatch(getNewCoursesRequest({ offset }));
    } else {
      dispatch(getWaitingCoursesRequest({ offset }));
    }

    setCurrentPages((prev) => ({
      ...prev,
      [type]: page,
    }));
  };

  const paginate = () => {
    setCurrentPage(1);
  };

  const handleEachCourse = (comp, course, type) => {
    let cor = course;
    cor["type"] = type;
    handleView(comp, cor);
  };
  const handleSearch = (search, type) => {
    setSearchCourse(prev => ({ ...prev, [type]: search }));
    if (type === 'myCourse') {
      dispatch(getCoursesRequest(0, 4, false, search, slug?.myCourse))
    } else if (type === 'newCourse') {
      dispatch(getNewCoursesRequest(0, search, slug?.newCourse))
    } else {
      dispatch(getWaitingCoursesRequest(0, search, slug?.waitingCourse))
    }
  };
  const style = {
    img: {
      width: 40,
      height: 40,
      marginBottom: 10,
      marginTop: 10,
    },
    icon: {
      fontSize: 25,
      marginRight: 10,
    },
  };
  useEffect(() => {
    dispatch(getProfileRequest());
    dispatch(getCoursesRequest({ offset: 0 }));
    dispatch(getNewCoursesRequest({ offset: 0 }));
    dispatch(getWaitingCoursesRequest({ offset: 0 }));
  }, []);

  useEffect(() => {
    if (slugList.length) {
      let arr = [{
        id: 0,
        value: 'All',
        label: 'All',
      }];
      slugList.forEach((fe) => {
        let data = {
          id: fe.id,
          value: fe.title,
          label: fe.title,
        };
        arr.push(data);
      });
      setSlugOptions(arr);
    }
  }, [slugList]);

  const handleCreateNew = () => {
    if (isCardAdded) {
      handleView("new")
    } else {
      handlePopup('isFreeCourse', true)
    }
  }


  return (
    <Container>
      {isInstructor ? (
        <IconButton
          text={"Create New"}
          style={{ width: 110, marginRight: 10, }}
          onClick={handleCreateNew}
          textStyle={{ fontWeight: "500" }}
          icon={!stripeLoading ? images.plus:null}
          iconStyle={{ height: 10, width: 10, marginRight: 5 }}
          loading={stripeLoading}
          disabled={stripeLoading}
        />
      ) : (
        <></>
      )}
      {/* ================================= My Courses ================================ */}

      <SpaceBetween>
        <HorizontalLeftAlign style={{ marginTop: 10 }}>
          <SchoolIcon style={style.icon} />
          <BoldLg>
            My Courses {my_courses_count ? ` (${my_courses_count})` : ""}
          </BoldLg>
        </HorizontalLeftAlign>

        <CourseHeading >
          <SearchDiv>
            <SearchBar
              search={searchCourse.myCourse}
              handleSearch={e => handleSearch(e, 'myCourse')}
              style={styles.searchStyle}
              placeholder={'Search My Course'} />
          </SearchDiv>
          <CustomSelect
            value={slug}
            onChange={e => handleSlug(e, 'myCourse')}
            placeholder={"Search by Slug"}
            options={slugOptions}
            mainStyle={styles.mainStyle}
          />
        </CourseHeading>
      </SpaceBetween>
      <>
        {courseLoading ? (
          <VerticalAlign style={{ height: 145 }}>
            <ClipLoader color={Colors.primary} size={20} />
          </VerticalAlign>
        ) : courses.length ? (
          <VerticalAlign>
            <PopularCourseContent>
              {courses.map((each) => (
                <PopularCourse
                  key={each?.id}
                  onClick={() => handleEachCourse("details", each, "mine")}
                  course_tpe={"mine"}
                >
                  <SpaceBetween>
                    <VerticalLeftAlign>
                      <SmartImage
                        src={each?.banner ? each?.banner : images.course}
                        style={style.img}
                      />
                      <BoldLg>{each?.title}</BoldLg>
                      <TruncatedText>
                        <RegSm style={{ color: Colors.lightTxt }}>
                          {each?.description}
                        </RegSm>
                      </TruncatedText>
                    </VerticalLeftAlign>
                    <ChevronRightIcon />
                  </SpaceBetween>
                </PopularCourse>
              ))}
            </PopularCourseContent>
          </VerticalAlign>
        ) : (
          <HorizontalAlign style={{ marginVertical: 10, width: "100%" }}>
            <RegSmPri>No courses to show</RegSmPri>
          </HorizontalAlign>
        )}


        <HorizontalAlign>
          <Pagination
            postsPerPage={4}
            totalPosts={my_courses_count}
            paginate={paginate}
            currentPage={currentPage.myCourses}
            setCurrentPage={(e) => setCurrentPage(e, "myCourses")}
          />
        </HorizontalAlign>
      </>
      {/* ================================= Register/ Popular Courses ================================ */}
      <SpaceBetween style={{ marginTop: 10 }}>
        <HorizontalLeftAlign style={{ marginTop: 15 }}>
          <SchoolIcon style={style.icon} />
          <BoldLg>
            {isInstructor ? "Popular Courses" : "Register New Courses"}
            {!isInstructor ? ` (${new_courses.length})` : ""}
          </BoldLg>
        </HorizontalLeftAlign>
        <CourseHeading >
          <SearchDiv>
            <SearchBar
              search={searchCourse.newCourse}
              handleSearch={e => handleSearch(e, 'newCourse')}
              style={styles.searchStyle}
              placeholder={'Search Popular Courses'} />
          </SearchDiv>
          <CustomSelect
            value={slug}
            onChange={e => handleSlug(e, 'newCourse')}
            placeholder={"Search by Slug"}
            options={slugOptions}
            mainStyle={styles.mainStyle}
          />
        </CourseHeading>
      </SpaceBetween>

      <>
        {newCourseLoading ? (
          <VerticalAlign style={{ height: 145 }}>
            <ClipLoader color={Colors.primary} size={20} />
          </VerticalAlign>
        ) : new_courses.length ? (
          <VerticalAlign>
            <PopularCourseContent isInstructor={isInstructor}>
              {new_courses.map((each) => (
                <PopularCourse
                  key={each?.id}
                  onClick={() => handleEachCourse("details", each, "new")}
                  course_tpe={"new"}
                >
                  <SpaceBetween>
                    <VerticalLeftAlign>
                      <SmartImage
                        src={each?.banner ? each?.banner : images.course}
                        style={style.img}
                      />
                      <BoldLg>{each?.title}</BoldLg>
                      <TruncatedText>
                        <RegSm style={{ color: Colors.lightTxt }}>
                          {each?.description}
                        </RegSm>
                      </TruncatedText>
                    </VerticalLeftAlign>
                    <ChevronRightIcon />
                  </SpaceBetween>
                </PopularCourse>
              ))}
            </PopularCourseContent>
          </VerticalAlign>
        ) : (
          <HorizontalAlign style={{ marginVertical: 10, width: "100%" }}>
            <RegSmPri>No courses to show</RegSmPri>
          </HorizontalAlign>
        )}
        {!isInstructor && (
          <HorizontalAlign>
            <Pagination
              postsPerPage={4}
              totalPosts={new_courses_count}
              paginate={paginate}
              currentPage={currentPage.newCourses}
              setCurrentPage={(e) => setCurrentPage(e, "newCourses")}
            />
          </HorizontalAlign>
        )}{" "}
      </>

      {/* ================================= Awaiting Courses ================================ */}

      <SpaceBetween style={{ marginTop: 10 }}>
        <HorizontalLeftAlign style={{ marginTop: 15 }}>
          <SchoolIcon style={style.icon} />
          <BoldLg>
            Awaiting Approval Courses{" "}
            {awaiting_courses_count ? ` (${awaiting_courses_count})` : ""}
          </BoldLg>
        </HorizontalLeftAlign>
        <CourseHeading >
          <SearchDiv >
            <SearchBar
              search={searchCourse.waitingCourse}
              handleSearch={e => handleSearch(e, 'waitingCourse')}
              style={styles.searchStyle}
              placeholder={'Search Awaiting Courses'} />
          </SearchDiv>
          <CustomSelect
            value={slug}
            onChange={e => handleSlug(e, 'waitingCourse')}
            placeholder={"Search by Slug"}
            options={slugOptions}
            mainStyle={styles.mainStyle}
          />
        </CourseHeading>
      </SpaceBetween>

      <>
        {waitingCourseLoading ? (
          <VerticalAlign style={{ height: 145 }}>
            <ClipLoader color={Colors.primary} size={20} />
          </VerticalAlign>
        ) : awaiting_courses?.length ? (
          <VerticalAlign>
            <PopularCourseContent>
              {awaiting_courses.map((each) => (
                <PopularCourse
                  key={each?.id}
                  onClick={() => handleEachCourse("details", each, "waiting")}
                  course_tpe={"waiting"}
                >
                  <VerticalLeftAlign>
                    <SmartImage
                      src={each?.banner ? each?.banner : images.course}
                      style={style.img}
                    />
                    <BoldLg>{each?.title}</BoldLg>
                    <TruncatedText>
                      <RegSm style={{ color: Colors.lightTxt }}>
                        {each?.description}
                      </RegSm>
                    </TruncatedText>
                  </VerticalLeftAlign>
                </PopularCourse>
              ))}
            </PopularCourseContent>
          </VerticalAlign>
        ) : (
          <HorizontalAlign style={{ marginVertical: 10, width: "100%" }}>
            <RegSmPri>No courses to show</RegSmPri>
          </HorizontalAlign>
        )}
        <HorizontalAlign>
          <Pagination
            postsPerPage={4}
            totalPosts={awaiting_courses_count}
            paginate={paginate}
            currentPage={currentPage.waitingCourses}
            setCurrentPage={(e) => setCurrentPage(e, "waitingCourses")}
          />
        </HorizontalAlign>
      </>
      {openPopup?.addCard && (
        <ModalComponent
          closeModal={closeModal}
          openModal={openPopup?.addCard}
          heading={`Card Details`}
          yesBtnTxt={"Add Now"}
          noBtnTxt={"Cancel"}
          yesBtn={addCard}
          noBtn={closeModal}
        >
          <RegLg>
            You haven't added your Bank details, please add Bank details now
          </RegLg>
        </ModalComponent>
      )}
      {openPopup?.isFreeCourse && (
        <ModalComponent
          closeModal={closeModal}
          openModal={openPopup?.isFreeCourse}
          heading={`Course Type`}
          yesBtnTxt={"Paid"}
          noBtnTxt={"Free"}
          yesBtn={handlePaidCourse}
          noBtn={()=>handleView("new")}
        >
          <RegLg>
            Do you want to create Free course or Paid course
          </RegLg>
        </ModalComponent>
      )}

    </Container>
  );
};

export default CoursesList;
